import React, { useState } from 'react'
import styled from "styled-components"
import Navbar from '../components/Navbar'
import Announcement from '../components/Announcement'
import Footer from '../components/Footer'
import { Add, Remove } from '@mui/icons-material'
import { mobile } from '../responses'
import { useSelector } from 'react-redux'
import { productsSelector, quantitySelector, totalpriceSelector } from '../redux/cartRedux'
import {handleCheckOut} from '../PayPages/PayButton'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const Container=styled.div`
`
const Wrapper=styled.div`
    padding: 20px;
  ${mobile({padding:"10px"})};
`
const Title=styled.h1`
    text-align: center;
    font-weight: 300;
`
const Form=styled.form`
    display: flex;
    flex-wrap: wrap;
`
const Button=styled.button`
    width: 100%;
    padding: 15px 20px;
    background-color: black;
    cursor:pointer ;
    font-weight: 600;
    color: white;
`
const Top=styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
`
const TopButton=styled.button`
    padding: 10px;
    font-weight: 600;
    cursor: pointer;
    border: ${props=>props.type==="filled"&&"none"};
    background-color: ${props=>props.type==="filled"?"black":"transparent"};
    color: ${props=>props.type==="filled"&&"white"};
`

const TopTexts=styled.div`
  ${mobile({display:"none"})};

`
const TopText=styled.span`
    text-decoration: underline;
    cursor: pointer;
    margin: 0px 10px;
    
    `
    const Bottom=styled.div`
        display: flex;
        justify-content: space-between;
  ${mobile({flexDirection:"column"})};
    `
    const Info=styled.div`
        flex: 3;
    `
const Product=styled.div`
    display: flex;
    justify-content: space-between;
  ${mobile({flexDirection:"column"})};
  height: 150px;
  margin: 10px 0px;
    `
const ProductDetails=styled.div`
    flex: 2;
    display: flex;
    /* justify-content: space-around; */
    `
const Image=styled.img`
    height: 100%;
    width: 40%;
    object-fit: contain;
  ${mobile({width:"50%"})};

    `
const Details=styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    
    `
const ProductName=styled.span``
const ProductId=styled.span``
const ProductColor=styled.div`
    width: 20px;
    height: 20px;
    box-shadow: 0px 0px 3px 0px;
    border-radius: 50%;
    background-color: ${props=>props.color};
    `
const ProductSize=styled.span``
const PriceDetails=styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    `
const ProductAmountContainer=styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;
    `
const ProductPrice=styled.div`
    font-size: 24px;
    margin: 5px;
  ${mobile({marginBottom:"20px"})};
    `
const ProductAmount=styled.div`
    font-size: 30px;
    font-weight: 200;
  ${mobile({margin:"5px 15px"})};

    `
const Hr=styled.hr`
    background-color: #eee;
    border: none;
    height: 1px;
    `
    const Summary=styled.div`
        flex: 1;
        border: 0.5px solid lightgray;
        border-radius: 10px;
        padding: 20px;
        height: 50vh;
        position: sticky;
        top: 10%;


    `
const SummaryTitle=styled.h1`
    /* flex: 1; */
    font-weight: 200;

    
`
const SummaryItem=styled.div`
    margin: 30px 0px;
    display: flex;
    justify-content: space-between;
    font-weight:${props=>props.type==="total"&&"500"} ;
    font-size:${props=>props.type==="total"&&"24px"} ;
`
const SummaryItemText=styled.span``
const SummaryItemPrice=styled.span``
const SummaryButton=styled.button``


const Cart = () => {
    const navigate=useNavigate()
    

    const productsAdded=useSelector(productsSelector)
    const productsAmount=useSelector(totalpriceSelector)
    const cartQuantity=useSelector(quantitySelector)
    console.log({productsAdded,productsAmount,cartQuantity});
    const [quantity,setQuantity]=useState(0)
    const handleQuantity=(type)=>{
        if(type==="asc"){
            setQuantity(pre=>pre+1)
        }else{
            setQuantity(pre=>pre-1<0?0:pre-1)
        }
    }
    
  return (
    <Container>
        <Navbar/>
        <Announcement/>
        <Wrapper>
            <Title>YOUR BAG </Title>
            <Top>

                <TopButton onClick={()=>navigate("/products")}>
                    CONTINUE SHOPPING
                </TopButton>
                <TopTexts>
                   <TopText>Shopping Bag(2)</TopText> 
                   <TopText >Your Wishlist(0)</TopText> 
                </TopTexts>
                <TopButton type="filled">
                    CHECKOUT NOW
                </TopButton>
            </Top>
            <Bottom>
                <Info>
                    {
                productsAdded.length? productsAdded.map(cartProduct=>{
                    // setQuantity()
                    return (
                        

                    <Product key={cartProduct._id}>
                    <ProductDetails>
                        <Image src={cartProduct?.img || "https://i.ibb.co/WPT8SN7/pngwing-com.png"}/>
                        <Details>
                            <ProductName> <b>product:</b> {cartProduct?.title}</ProductName>
                            <ProductId> <b>ID:</b>{cartProduct._id}</ProductId>
                            <ProductColor color={cartProduct?.color}/>
                            <ProductSize> <b>Size:</b> {cartProduct?.size}</ProductSize>
                        </Details>
                    </ProductDetails>
                    <PriceDetails>
                        <ProductAmountContainer>
                                <Add onClick={()=>handleQuantity("asc")} />
                                <ProductAmount>{quantity||cartProduct.quantity}</ProductAmount>
                                <Remove onClick={()=>handleQuantity("dec")}  />
                        </ProductAmountContainer>
                        <ProductPrice>&#8377;{cartProduct?.price}</ProductPrice>
                    </PriceDetails>
                    <Hr/>
                </Product>
                
                    )
                } )  :
                 <ProductDetails>
                        <Image src={ "https://i.ibb.co/WPT8SN7/pngwing-com.png"}/>
                        <Details>
                            <h1>Empty Cart</h1>
                        </Details>
                    </ProductDetails>  
                }

                </Info>
                <Summary>
                    <SummaryTitle>
                        ORDER SUMMARY
                    </SummaryTitle>
                    <SummaryItem>
                        <SummaryItemText>
                            Subtotal
                        </SummaryItemText>
                        <SummaryItemPrice>
                        &#8377; {productsAmount}
                        </SummaryItemPrice>
                    </SummaryItem>
                    <SummaryItem>
                        <SummaryItemText>
                            Estimated Shipping
                        </SummaryItemText>
                        <SummaryItemPrice>
                            $ 5.9
                        </SummaryItemPrice>
                    </SummaryItem>
                    <SummaryItem>
                        <SummaryItemText>
                            Shipping Discount
                        </SummaryItemText>
                        <SummaryItemPrice>
                            $ -5.9
                        </SummaryItemPrice>
                    </SummaryItem>
                    <SummaryItem type="total">
                        <SummaryItemText >
                            Total
                        </SummaryItemText>
                        <SummaryItemPrice>
                        &#8377;  {productsAmount}
                        </SummaryItemPrice>
                    </SummaryItem>
                    <Button onClick={()=>handleCheckOut(productsAdded)}>CHECKOUT NOW</Button>
                </Summary>
            </Bottom>
        </Wrapper>
        <Footer/>
    </Container>
  )
}

export default Cart
